import Table from '../../../../../common/components/table';


export const OneProgramValuesComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedProgramValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedProgramValues}
                onEdit={handleEdit} headingName="One Program Details"
            />
        </div>
    )
}
export default OneProgramValuesComponent;
